module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      'animate-flex-modal': _vm.show === true
    },
    attrs: {
      "id": "share-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('shareSocialNetworks')))]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.currentUrl,
      "title": _vm.mapName,
      "description": "Mapa creat a Instamaps.cat"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "networks-list",
            staticStyle: {
              "margin-bottom": "24px"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-linkedin"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fa fa-pinterest"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('shareMail')))]), _vm._v(" "), _c('div', {
    staticClass: "networks-list"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.mailTo,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7742c7cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/share-modal/share-modal.vue
// module id = 135
// module chunks = 0